import React from "react";
import LoadingIndicator from "./LoadingIndicator";

const LoadingButton = ({
  loading = false,
  disabled = false,
  loadingLabel = "Loading...",
  children,
  className = "",
  type = "button",
  invert = false,
  ...props
}) => {
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      disabled={isDisabled}
      aria-busy={loading ? "true" : "false"}
      className={className}
      {...props}
    >
      {loading ? (
        <LoadingIndicator
          label={loadingLabel}
          size="sm"
          invert={invert}
          className="justify-center"
        />
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingButton;
